import type { ChangeEvent } from "react";

import { callAll } from "../../../../utils/call-all";
import { SEARCH_MENU_SEARCH_LABEL } from "../../search-menu.messages";
import { useSearchMenuContext } from "../../search-menu.context";
import type { SearchMenuSearchProps, SearchMenuSearchViewProps } from "./types-search";

/** ViewModel do SearchMenu.Search: valor da busca e handlers que compõem (`callAll`) os internos com os da tela; sem JSX. */
export function useSearchMenuSearch({
  testId,
  className,
  onChange,
  onKeyDown,
  ...rest
}: SearchMenuSearchProps): SearchMenuSearchViewProps {
  const { inputValue, buscar, onSearchKeyDown } = useSearchMenuContext();

  return {
    testId,
    className,
    ariaLabel: SEARCH_MENU_SEARCH_LABEL,
    value: inputValue,
    onChange: callAll(
      (event: ChangeEvent<HTMLInputElement>) => buscar(event.target.value),
      onChange,
    ),
    onKeyDown: callAll(onSearchKeyDown, onKeyDown),
    rest,
  };
}
